export function sanitizeAuthNext(raw: string | null | undefined): string {
  if (!raw || !raw.startsWith('/') || raw.startsWith('//')) return '/'

  try {
    const url = new URL(raw, 'http://localhost')
    if (url.pathname === '/login') return '/'
    return `${url.pathname}${url.search}${url.hash}` || '/'
  } catch {
    return '/'
  }
}

export function buildLoginRedirect(next: string): string {
  const sanitizedNext = sanitizeAuthNext(next)
  return sanitizedNext === '/' ? '/login' : `/login?next=${encodeURIComponent(sanitizedNext)}`
}
